// extracted by mini-css-extract-plugin
export default {"AdSlotOffsite":"bgt_a bhs_bi"};